import Play from "./components/play/Play";
import DemoPanel from "./DemoPanel";
import DemoContainer from "./DemoContainer";
import { connect } from 'react-redux';

import './scss/App.scss'
import React from "react";

import { cssStyles } from "./utils/constants";
import { fetchContests, updateContest } from "./redux/contests/actions";
import { getStatusFetched } from "./redux/contests/selectors";
import { setAuth } from "./redux/auth/actions";
import { getRunningSeries } from "./services/ContestSeries";
import axios from "axios";
import { removeDupConfig } from "./utils/utils";


const queryString = require('query-string');

class App extends React.Component<any> {

  public static  Instance : App;

  urlParams = queryString.parse(window.location.search);
  
  currentStyle : any;
  interval: any;

  state = {demo:false , selectedStyle:-1}

  constructor(props : any)
  {
    super(props)
    App.Instance = this;

    this.state = {
      demo: this.urlParams.demo === 'true' ? true : false ,
      selectedStyle:-1
    }
  }

  
  public static getPropertyFromStyle(name : string) :any {

    if(!App.Instance.currentStyle)
      return '';

    const len = App.Instance.currentStyle.length;
    for(let i = 0 ; i < len;i++){
      if(App.Instance.currentStyle[i].property === name)
        return App.Instance.currentStyle[i].value;
    }
  }


  componentDidMount = async ()=>{
    const series = await getRunningSeries();
    this.interval = setInterval(()=> {
    this.props.getStatusFetched && this.props.fetchContests(null, series)
    }, 1000)

    setTimeout(() => {
      this.loadStyles();
    }, 10);
    this.loadStyles();
    this.setAuth()
  }

  loadStyles = ()=>{
    if (this.urlParams.themeSource) {
      axios.get(`${this.urlParams.themeSource}`)
      .then((response: any) => {
         const configTheme = Object.entries(response.data).map(([key, value]) => ({
          property : key,
          value
        }))
        this.updateStyle(configTheme, null); 
      })
      .catch((error: any) => {
        console.log(error);
        const styleNumber = this.urlParams.id ? Number(this.urlParams.id) : 0;
        this.updateStyle([], styleNumber);
      });
    } else {
      const styleNumber = this.urlParams.id ? Number(this.urlParams.id) : 0;
      this.updateStyle([], styleNumber); 
    }
  }
  setAuth = () => {
    const auth = this.urlParams.token || ''
    if (auth) {
      this.props.setAuth({
        userId: this.urlParams.userid ? this.urlParams.userid  : '',
        token: this.urlParams.token,
        refreshToken: this.urlParams.refreshToken ? this.urlParams.refreshToken : '',
      })
    }
  }

  updateStyle = (config: any[], id: number)=>{
    this.currentStyle = !config.length ? cssStyles[id] : removeDupConfig([...cssStyles[0], ...config], 'property');
    this.currentStyle.forEach((style : any) =>{
      document.documentElement.style.setProperty(style.property , style.value);
    })
  }

  render() {
    return(
      <div className="app">
        {this.getAppliction()}
      </div>
    )
  }

  onStyleChange = (id:number)=>{
    this.setState({selectedStyle:id});
    if(id === -1)
      this.updateStyle([], 0);
    else
      this.updateStyle([], id);
  }

  getAppliction = ()=>{
    if(this.state.demo){
      if(this.state.selectedStyle === -1)
        return <DemoPanel onStyleChange={this.onStyleChange}/>
      else
        return <DemoContainer onStyleChange={this.onStyleChange}  skin={this.state.selectedStyle}/>
    }
    else{
      return <Play/>
    }
  }
}

const mapActionsToProps = (dispatch:any) => ({
  fetchContests: (contests:any, series:any) => dispatch(fetchContests(contests, series)),
  updateContest: (contestUpdate:any) => dispatch(updateContest(contestUpdate)),
  setAuth: (userId:string) => dispatch(setAuth(userId))
});

const mapStateToProps = (state:any) => ({
  getStatusFetched: getStatusFetched(state),
})

export default connect(mapStateToProps, mapActionsToProps)(App);
